import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from './Modal';
import { openModal, resetModal } from '../actions/modalsActions';
import i18n from '../utils/i18n';
import { modals } from '../utils/constants';

class CancellationConfirmModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: false
    };

    this.postGiveBack = this.postGiveBack.bind(this);
  }

  postGiveBack() {
    const { confirmAction, refreshAction } = this.props.modalData;

    confirmAction()
      .then(() => {
        this.props.dispatch(refreshAction);
        this.props.openModal(modals.CANCELLATION_RESULT, {
          translationNamespace: this.props.modalData.translationNamespace
        });
      })
      .catch(() => {
        this.setState({ errors: true });
      });
  }

  render() {
    const { errors } = this.state;
    const { resetModal, modalData } = this.props;
    const translationName = `modals.${modalData.translationNamespace}.confirm`;
    return (
      <Modal
        isOpen={true}
        onRequestClose={resetModal}
        closeButtonText={i18n.t(`${translationName}.CANCEL_BUTTON`)}
        actionButtonText={i18n.t(`${translationName}.ACTION_BUTTON`)}
        actionFunction={() => this.postGiveBack()}
      >
        <div className="modal-container">
          <h1 className="modal-header">{i18n.t(`${translationName}.TITLE`)}</h1>
          <div className="form-container">
            {i18n.t(`${translationName}.TEXT_1ST_LINE`)}
            <br />
            {i18n.t(`${translationName}.TEXT_2ND_LINE`)}
            <br />

            {errors && (
              <div className="text-danger">
                {i18n.t(`${translationName}.ERROR`)}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

CancellationConfirmModal.propTypes = {
  modalData: PropTypes.shape({
    refreshAction: PropTypes.func.isRequired,
    confirmAction: PropTypes.func.isRequired,
    translationNamespace: PropTypes.string.isRequired
  }).isRequired,
  resetModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  modalData: state.modals.modalData
});

const mapDispatchToProps = dispatch => ({
  resetModal: () => dispatch(resetModal()),
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData)),
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(
  CancellationConfirmModal
);



// WEBPACK FOOTER //
// ./src/modals/CancellationConfirmModal.js